import "./leaderboards.scss"
import imgCrown from '../assets/leaderboard-crown.png'
import Spinner from './spinner'
import { useMemo } from 'react'
import { sha256 } from 'js-sha256'
import classNames from 'classnames'

// const GAME_NAMES = {
//     FLAPPY_BLOCK: 'Flappy Block',
//     MEMORY_BLOCK: 'Memory Block',
//     WHACK_A_BLOCK: 'Whack-A-Block',
// }

const GAME_IDS = {
    FLAPPY_BLOCK: 'flappy_games',
    MEMORY_BLOCK: 'memory_games',
    WHACK_A_BLOCK: 'whack_games',
}

const Leaderboards = props => {
    const numPlayed = props.stats.find( data => {
        return data.name === GAME_IDS[ props.game ]
    } )?.value

    const emailHash = useMemo( () => sha256( props.email ), [ props.email ] )

    return (
        <div className="game-window__leaderboards">
            <img className="game-window__leaderboards__icon" src={ imgCrown } alt="Crown icon" />
            <h2>Leaderboard</h2>
            <div className="game-window__leaderboards-wrapper">
                { props.scores.length === 0 && <Spinner /> }
                { Boolean(numPlayed) && <div className="game-window__leaderboards-note">{ `${ numPlayed.toLocaleString() } games played` }</div> }
                { props.scores.slice( 0, 200 ).map( ( data, i ) => {
                    const className = classNames( 'leaderboard-entry', {
                        'leaderboard-entry--highlight': emailHash === data.email_hash
                    })
                    return <div className={ className } key={ `player-${ i }` }>
                        <div className="leaderboard-entry__place" data-place={ i + 1 }>{ i + 1 }</div>
                        <div className="leaderboard-entry__name">{ data.alias }</div>
                        <div className="leaderboard-entry__score">{ data.score }</div>
                    </div>
                } ) }
            </div>
        </div>

    )
}

Leaderboards.defaultProps = {
    game: 'FLAPPY_BLOCK',
    scores: [], // From the getLeaderBoard api call.
    stats: [],
    email: '',
}

export default Leaderboards